export const CREATE_RENT_RECORD = "CREATE_RENT_RECORD";
export const FETCH_RENT_RECORDS = "FETCH_RENT_RECORDS";
export const FETCH_RENT_RECORD = "FETCH_RENT_RECORD";
export const EDIT_RENT_RECORD = "EDIT_RENT_RECORD";
export const DELETE_RENT_RECORD = "DELETE_RENT_RECORD";
